var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-4.309 -132.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.687,14H5.313a.584.584,0,1,1,0-1.157h6.375a.584.584,0,1,1,0,1.157Zm1.328-2.315H3.983A3.757,3.757,0,0,1,0,8.216V3.471A3.759,3.759,0,0,1,3.984,0h6.575a.627.627,0,0,1,.664.579.627.627,0,0,1-.664.579H3.984A2.506,2.506,0,0,0,1.328,3.471V8.216a2.5,2.5,0,0,0,2.655,2.313h9.032a2.506,2.506,0,0,0,2.656-2.314v-2.6a.67.67,0,0,1,1.328,0v2.6A3.758,3.758,0,0,1,13.016,11.686Z",
    transform: "translate(4.309 132.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M1.057,5.583H.664A.627.627,0,0,1,0,5a.626.626,0,0,1,.664-.578h.392A8.9,8.9,0,0,0,7.084,2.146a.709.709,0,0,1,.48-.179.716.716,0,0,1,.458.16.545.545,0,0,1,.206.408.535.535,0,0,1-.184.41A10.316,10.316,0,0,1,1.057,5.583ZM9.689,3.876A.627.627,0,0,1,9.025,3.3V1.77a.663.663,0,0,0-.7-.613H6.568A.627.627,0,0,1,5.9.579.627.627,0,0,1,6.568,0H8.322a1.917,1.917,0,0,1,2.031,1.77V3.3A.627.627,0,0,1,9.689,3.876Z",
    transform: "translate(10.955 132.078)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3a3f8477122d21f21f1a444a9ce33ba7.svg";
export { ForwardRef as ReactComponent };